import request from "@/shared/config/request";
import { ENDPOINTS } from "@/shared/constants/api";
import { Config } from "@/shared/types/config";

export async function getConfig(): Promise<Config> {
  return await request
    .get<Config>(ENDPOINTS.GET_CONFIG)
    .then((response) => response.data);
}
